/**
 * @author：
 * @update：
 * @description：
 **/
export default {
    /**
     * treeData 左侧全部列表数据
     * isOpenBol 是否打开弹窗
     * checkDataes 右侧已选内容
     * modelName 弹窗标题
     * resourceName 资源名称
     * */
    props:{'treeData':{},'isOpenBol':{},'checkDataes':{},'modelName':{default:'接口权限'},'resourceName':'',resourceTitle:{default:'资源名称'}},
    data() {
        return {
            defaultProps: {
                children: 'children',
                label: 'label'
            },
            filterText:'',//搜索框输入内容
            delListBol:false,//是否显示多选框
            isIndeterminate:false,//是否半选
            checkAll:false,//是否全选
            checkedKey:[],//右侧勾选内容id

            leftData:[],//左侧内容
            rightData:[],//右侧内容
            dataAllList:[],//要删除的内容
        };
    },
    // 自定义方法
    methods: {
        //模态框关闭
        modelClose(){
            this.$emit('modelClose','');
            this.dataAllList=[];
            this.delListBol = false;
            this.isIndeterminate = false;

            this.checkedKey = [];
            this.leftData = [];
            this.rightData = [];
        },
        //树状图搜索
        // treeSearch(){
        //
        // },
        //树状图过滤搜索函数
        filterNode(value, data) {
            if (!value) return true;
            return data.label.indexOf(value) !== -1;
        },
        //树状图选中
        handleCheckChange(data, checked){
            if(checked.checkedKeys.includes(data.id)){
                this.rightData.push(this.leftData[this.leftData.findIndex(item => item.id === data.id)])
            }else{
                this.rightData.splice(this.rightData.findIndex(item => item.id === data.id), 1);
            }
        },
        //全选框
        handleCheckAllChange(val){
            this.dataAllList = val ? this.rightData.map(item => item.id) : [];
            this.isIndeterminate = false;
        },
        //删除时多选框点击事件
        handleCheckedCitiesChange(value){
            let checkedCount = value.length;
            this.checkAll=checkedCount === this.rightData.length;
            this.isIndeterminate=checkedCount > 0 && checkedCount < this.rightData.length;
        },
        //清空按钮
        empty(){
            this.rightData = [];//右侧数据清空
            this.$refs.tree.setCheckedKeys([]);//左侧树状图选中状态清空
        },
        //删除
        delList(id){
            this.rightData.splice(this.rightData.findIndex(item => item.id === id), 1);
            this.$refs.tree.setChecked(id,false,false);
        },
        //确定移除
        delMoreList(){
            let data = this.dataAllList;
            this.$emit('delMoreList',data);
            this.dataAllList=[];
            this.delListBol = false;
        },
        //接口权限批量移除
        interfaceDelBtn(){
            this.checkAll = false;
            this.delListBol = true;
        },
        //提交
        interfaceBtn(){
            this.$emit('interfaceBtn',this.rightData);
            this.delListBol = false;
        },
    },
    // 数据观察监听
    watch: {
        filterText(val) {
            this.$refs.tree.filter(val);
        },
        treeData(newName, oldName){
            this.leftData = newName;
        },
        checkDataes(newName, oldName) {
            let arr = [];
            for(let i = 0; i < newName.length; i++){
                arr.push(newName[i].id)
            }
            this.checkedKey = arr;
            this.rightData = newName
        }
    },
    // 计算数据
    computed: {

    },
    // 组件数据创建之前
    beforeCreate() {

    },
    // 组件数据创建完成
    created() {

    },
    // 组件挂载完成之前
    beforeMount() {

    },
    // 组件挂载完成
    mounted() {

    },
    // 组件即将销毁
    beforeDestroy() {

    },
    // 组件销毁
    destroyed() {

    },
    // 组件激活
    activated() {

    },
    // 组件冻结
    deactivated() {

    }
};
